import { useStyles } from "../context";
import { CoreTripsComponent, CORE_TRIPS_NAME } from "@b2bportal/core-types";

export const useTripsStyles = (
  componentName: keyof typeof CoreTripsComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_TRIPS_NAME, componentName, defaultStyles);
};
